import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" LOAD MORE ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("No hounds found in leaderboard.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_leaderboard_list_item = _resolveComponent("leaderboard-list-item")!
  const _component_chevron_down = _resolveComponent("chevron-down")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_divider = _resolveComponent("n-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_grid, {
      cols: "12",
      "x-gap": "24",
      "y-gap": "24",
      "item-responsive": "",
      responsive: "screen"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_gi, {
          span: "12",
          class: "hounds-table"
        }, {
          default: _withCtx(() => [
            (_ctx.items.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (hound, id) => {
                    return (_openBlock(), _createBlock(_component_leaderboard_list_item, {
                      key: hound.id,
                      index: id,
                      hound: hound
                    }, null, 8, ["index", "hound"]))
                  }), 128)),
                  _createVNode(_component_n_space, { justify: "center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_button, {
                        onClick: _ctx.loadMore,
                        type: "primary"
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_n_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_chevron_down)
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createBlock(_component_n_alert, {
                  key: 1,
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_space, { justify: "space-between" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_text, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_n_divider)
  ]))
}